import styles from './description.module.scss';

const SectionDescription = ({ description = '', isHtml = false }) => {
  const renderDescription = (text) => {
    if (isHtml) {
      return (
        <p
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    }

    return (
      <p
        className={styles.description}
        itemScope
        itemType='https://schema.org/Text'
      >
        {text}
      </p>
    );
  };

  return (
    <div
      className={`${styles.description}`}
      itemScope
      itemType='https://schema.org/Property'
    >
      {renderDescription(description)}
    </div>
  );
};

export default SectionDescription;
